import { ReactComponent as SmsIcon } from "../imgComponents/product-logo-icon-sms-marketing.svg";
import { ReactComponent as LoyaltyIcon } from "../imgComponents/product-logo-icon-loyalty.svg";
import { ReactComponent as ReviewsIcon } from "../imgComponents/product-logo-icon-reviews.svg";
import { ReactComponent as VisualUGCIcon } from "../imgComponents/product-logo-icon-visual-ugc.svg";
import "../../css/footer.scss";
import CTA from "../CTA";

const Footer = (props) => {
  const ypSellers = (typeof window.Cookies !== "undefined" && window.Cookies.get("_yp_seller")) || false;
  if ((typeof window.isVb !== "undefined" && window.isVb) || ypSellers) {
    return null;
  }

  const products = {
    SmsIcon: "SMS",
    LoyaltyIcon: "Loyalty & Referrals",
    ReviewsIcon: "Reviews",
    VisualUGCIcon: "Visual UGC",
  };

  const _dy_df_geo = (typeof window.Cookies !== "undefined" && window.Cookies.get("_dy_df_geo")) || false;
  let price = 500;
  let currencySign = "$";
  if (_dy_df_geo) {
    const country = _dy_df_geo.split(".")[0];
    if (country === "United Kingdom") {
      price = 400;
      currencySign = "£";
    }
    if (country === "Australia") {
      price = 700;
    }
  }
  return (
    <section id="bfcm-footer">
      <div className="bfcm-footer-container">
        <div className="footer-right">
          <img data-aos="fade-up" src={props.main_image_group["1x"]} className="main-img" alt="Yotpo" />
          <div className="products">
            {Object.entries(products).map((product, index) => (
              <span className={product[0] + " product font-regular"} key={index}>
                {product[0] === "SmsIcon" ? <SmsIcon /> : null}
                {product[0] === "LoyaltyIcon" ? <LoyaltyIcon /> : null}
                {product[0] === "ReviewsIcon" ? <ReviewsIcon /> : null}
                {product[0] === "VisualUGCIcon" ? <VisualUGCIcon /> : null}
                {product[1]}
              </span>
            ))}
          </div>
          <p data-aos="fade-up" className="main-text font-regular">
            {/* {props.text} */}
            We've got the retention solutions you need, at an exclusive price. Add Yotpo SMSBump, Loyalty, Reviews, or
            Visual UGC before BFCM and get {currencySign + price.toLocaleString()} or more off annual plans.
          </p>
        </div>
        <div className="footer-left">
          <div className="footer-left-content">
            <div className="one-product font-regular">
              <span className="starting">Starting at</span>
              <span className="price">
                {currencySign}
                {price.toLocaleString()} OFF
              </span>
              <span className="plans font-regular">an annual plan for any single Yotpo product.</span>
            </div>
            <span className="or-separator font-regular">or</span>
            <div className="one-product multi-product font-regular">
              <span className="starting">Starting at</span>
              <span className="price">
                {currencySign}
                {(price * 2).toLocaleString()} OFF
              </span>
              <span className="plans font-regular">
                On annual plans for <span className="colored">2 or more</span> Yotpo products.*
              </span>
            </div>
          </div>
          <CTA
            aos="fade-up"
            href={props.cta.url}
            title={props.cta.title}
            icon="arrow-right"
            segmentLocation="Discount footer"
          />
          <span className="terms font-regular">{props.exclusions}</span>
        </div>
      </div>
    </section>
  );
};

export default Footer;
